<template>

  <div>

    <router-view/>
  </div>

</template>

<script>
  // @vuese
  // This wraps the admin components
  // @group Wrappers
  export default {
    name:'Admin',
    components: {
     },


  };
</script>

